module.exports = __webpack_public_path__ + "static/media/settings_Profile_Management.f996d3ea.png";